<div class="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4 relative overflow-hidden">
  <!-- Hero Background Image -->
  <div class="absolute inset-0 z-0">
    <img
      src="assets/images/tree_mapper_hero.jpg"
      alt="Farm and Forest Mapper Hero"
      class="w-full h-full object-cover opacity-60"
    >
  </div>

  <!-- Login Card -->
  <div class="w-full max-w-md relative z-10">
    <div class="bg-white/80 backdrop-blur-md rounded-2xl shadow-xl p-8 border border-white/30">
      <!-- Header -->
      <div class="text-center mb-8">
        <h1 class="text-3xl font-bold text-gray-900 mb-2">Farm and Forest Mapper</h1>
        <p class="text-gray-700">Sign in to your account</p>
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="mb-6 p-4 bg-red-50/90 border border-red-200 rounded-lg">
        <div class="flex items-center">
          <svg class="w-5 h-5 text-red-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path>
          </svg>
          <span class="text-red-800 text-sm font-medium">{{ errorMessage }}</span>
        </div>
      </div>

      <!-- Login Form -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
        <!-- Email Field -->
        <div>
          <label for="email" class="block text-sm font-medium text-gray-800 mb-2">
            Email Address
          </label>
          <div class="relative">
            <input
              id="email"
              type="email"
              formControlName="email"
              placeholder="Enter your email"
              class="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 bg-white/90"
              [class.border-red-300]="isFieldInvalid('email')"
              [class.border-gray-300]="!isFieldInvalid('email')"
              [class.focus:border-red-500]="isFieldInvalid('email')"
              [class.focus:ring-red-500]="isFieldInvalid('email')"
            >
            <div *ngIf="isFieldInvalid('email')" class="mt-2 text-sm text-red-600 flex items-center">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
              </svg>
              {{ getFieldError('email') }}
            </div>
          </div>
        </div>

        <!-- Password Field -->
        <div>
          <label for="password" class="block text-sm font-medium text-gray-800 mb-2">
            Password
          </label>
          <div class="relative">
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="Enter your password"
              class="w-full px-4 py-3 pr-12 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 bg-white/90"
              [class.border-red-300]="isFieldInvalid('password')"
              [class.border-gray-300]="!isFieldInvalid('password')"
              [class.focus:border-red-500]="isFieldInvalid('password')"
              [class.focus:ring-red-500]="isFieldInvalid('password')"
            >
            <button
              type="button"
              (click)="togglePasswordVisibility()"
              class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors duration-200"
            >
              <svg *ngIf="!showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
              </svg>
              <svg *ngIf="showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"></path>
              </svg>
            </button>
            <div *ngIf="isFieldInvalid('password')" class="mt-2 text-sm text-red-600 flex items-center">
              <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
              </svg>
              {{ getFieldError('password') }}
            </div>
          </div>
        </div>

        <!-- Submit Button -->
        <button
          type="submit"
          [disabled]="!loginForm.valid || isLoading"
          class="w-full bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold py-3 px-4 rounded-lg hover:from-green-700 hover:to-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform disabled:scale-95"
        >
          <div *ngIf="isLoading" class="flex items-center justify-center">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Signing in...
          </div>
          <span *ngIf="!isLoading">Sign In</span>
        </button>
      </form>

      <!-- Links -->
      <div class="mt-6 text-center space-y-3">
        <div class="text-sm text-gray-700">
          Not a member?
          <a routerLink="/register" class="font-medium text-green-600 hover:text-green-500 transition-colors duration-200">
            Register Now
          </a>
        </div>
        <div>
          <a routerLink="/account/forgotPassword" class="text-sm text-gray-600 hover:text-gray-800 transition-colors duration-200">
            Forgot your password?
          </a>
        </div>
        <div class="text-sm  text-gray-700 flex items-center justify-center">
          <a class="font-medium text-green-600 hover:text-green-500 transition-colors duration-200"
             (click)="useAsGuest($event)">
            Use as Guest
          </a>
          <i class="fa fa-info-circle ml-3" tabindex="0"
             [eskPopover]="guestPopoverTxt"
             eskPopoverPlacement="right">
          </i>
        </div>
      </div>
    </div>
  </div>
</div>
